import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import type { Reply, SenderType } from '@/components/tickets/types';

export function useReplies(ticketId: string | undefined) {
  return useQuery({
    queryKey: ['replies', ticketId],
    queryFn: async () => {
      const res = await axios.get<{ replies: Reply[] }>(`/api/tickets/${ticketId}/replies`);
      return res.data.replies;
    },
    enabled: !!ticketId,
  });
}

export function useCreateReply(ticketId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ body, senderType }: { body: string; senderType: SenderType }) =>
      axios.post(`/api/tickets/${ticketId}/replies`, { body, senderType }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['replies', ticketId] });
    },
  });
}

export function usePolishReply(ticketId: string | undefined) {
  return useMutation({
    mutationFn: async (body: string) => {
      const res = await axios.post<{ polishedBody: string }>(
        `/api/tickets/${ticketId}/replies/polish`,
        { body },
      );
      return res.data.polishedBody;
    },
  });
}
